<template>
  <div class="hero is-white is- is-fullheight has-text-centered" style="position: fixed; width: 100%; z-index: 10; align-items: center;">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered is-vcentered">
          <div class="column has-text-centered is-12 is-7-desktop">
            <figure class="image" style="margin: 0 auto; height: auto; width: 100px;">
              <img src="/assets/img/logo-new-200.png"/>
            </figure>
            <br>
            <p>Demi meningkatkan kenyamanan dalam perkuliahan Anda, silakan buka Aplikasi Edlink.</p>
            <br>
            <div class="columns is-mobile is-centered">
              <div class="column is-7" v-if="$device.isIos">
                <a href="https://apps.apple.com/app/edlink/id1482222769">
                  <img src="/assets/img/appstorebutton.png" alt="">
                </a>
              </div>
              <div class="column is-7" v-else-if="$device.isAndroid">
                <a href="https://play.google.com/store/apps/details?id=id.co.sevima.edlink">
                  <img src="/assets/img/googleplaybutton.png" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
